export enum AppPermissions {
    cAPBasicUser = 'CAP_Basic_User',
    cAPFeatureAreasCanCreate = 'CAP-Feature_Areas-Can_Create',
    cAPFeatureAreasCanPublish = 'CAP-Feature_Areas-Can_Publish',
    cAPFeatureAreasCanUpdate = 'CAP-Feature_Areas-Can_Update',
    checkRidePilotExaminerAccess = 'Check_Ride-Pilot_Examiner_Access',
    checkRideStudentAccess = 'Check_Ride-Student_Access',
    checkridePaymentCanRefund = 'Checkride_Payment-Can_Refund',
    checkrideBasicAccess = 'Checkride-Basic_Access',
    checkrideCanSeeMissedAcsCodes = 'Checkride-Can_See_Missed_Acs_Codes',
    entAdminMetaDataCanAdmin = 'Ent_Admin_MetaDataCanAdmin',
    entAdminOtherCanAccess = 'Ent_Admin_OtherCanAccess',
    entAdminSecurityCanAccess = 'Ent_Admin_SecurityCanAccess',
    entAdminSecurityCanAdminAdvanced = 'Ent_Admin_SecurityCanAdminAdvanced',
    entAdminSecurityCanAdminUsers = 'Ent_Admin_SecurityCanAdminUsers',
    entAdminCanAccess = 'Ent_AdminCanAccess',
    entSecurityCanEmulate = 'Ent_Security_CanEmulate',
    entSecurityCanLogin = 'Ent_Security_CanLogin',
    entUiCanConfigure = 'Ent_Ui_CanConfigure',
    entUiContentCanEdit = 'Ent_Ui_Content_CanEdit',
    entWorkItemTrackingCanAccess = 'Ent_WorkItemTracking_CanAccess',
    entWorkItemTrackingCanAdmin = 'Ent_WorkItemTracking_CanAdmin',
    listAdmin = 'List_Admin',
    pilexosAdmin = 'Pilexos_Admin',
    pilexosUserTypeLimitedMenusCanSeeAll = 'Pilexos-User_Type_Limited_Menus-Can_See_All',
    pilotExaminerCanManage = 'Pilot_Examiner-Can_Manage',
    planOfActionACSCodeLookup = 'Plan_of_Action-ACS_Code_Lookup',
    planOfActionPilotExaminer = 'Plan_of_Action-Pilot_Examiner',
    planOfActionStudentAccess = 'Plan_of_Action-Student_Access',
}
